import { useHistory } from "react-router-dom";
import { Box } from "@mui/material";
import { trackWorkflowPageReached, type WorkflowPage } from "analytics";
import { getStandaloneSurveySlotSx } from "components/v3/layouts/StandaloneSurveyPageLayout";
import SurveyWrapper from "components/v3/sharedComponents/surveys/SurveyWrapper";
import { PATHS } from "constants/pathConstants";
import { Model } from "survey-core";
import {
  didMemberRequestNavigatorCallback,
  wasCologuardQualificationSurveyCompletedWithCologuardSuggestion
} from "utils/v3/nextMoveUtils";

export const SURVEY_ID = "cologuard-qualification-survey";

const CologuardQualificationSurvey = (): React.ReactElement => {
  const history = useHistory();

  const handleOnComplete = (surveyModel: Model): void => {
    const requestedNavigator = didMemberRequestNavigatorCallback(
      surveyModel.data
    );
    const offeredCologuard =
      wasCologuardQualificationSurveyCompletedWithCologuardSuggestion(
        surveyModel.data
      );
    const page: WorkflowPage = requestedNavigator
      ? "navigator_confirmation"
      : offeredCologuard
        ? "launch"
        : "dashboard";

    trackWorkflowPageReached({
      workflow: "colon_cancer_screening",
      page,
      workflowStep: "decision"
    });

    if (page === "navigator_confirmation") {
      history.push(PATHS.NAVIGATOR_REQUEST_CONFIRMATION, {
        analyticsWorkflow: "colon_cancer_screening"
      });
      return;
    }

    history.push(
      page === "launch" ? PATHS.COLOGUARD_LAUNCH_PAGE : PATHS.LANDING_PAGE
    );
  };

  const handleOnSurveyInstantiated = (surveyModel: Model): void => {
    surveyModel.pagePrevText = "Back";
    surveyModel.clearInvisibleValues = "onHiddenContainer";
  };

  return (
    <Box sx={getStandaloneSurveySlotSx(false)}>
      <SurveyWrapper
        containerClassName="cologuard-qualification-survey-container"
        fillViewport
        focusFirstQuestionAutomatic={false}
        onComplete={handleOnComplete}
        onSurveyInstantiated={handleOnSurveyInstantiated}
        overrideNextButtonEnabled={true}
        surveyId={SURVEY_ID}
      />
    </Box>
  );
};

export default CologuardQualificationSurvey;
